import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => {
  return {
    path: "question/:question_id",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "toddle-library" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
